// Table — a styled, responsive table wrapper. Handles the bordered card
// frame + horizontal overflow on narrow screens so you just write the
// <thead>/<tbody>. Token-driven header, row hover, and dark mode.
//
//   <Table hover>
//     <thead><tr><th>Name</th><th className="ui-table__num">Score</th></tr></thead>
//     <tbody>{rows.map(r => (
//       <tr key={r.id}><td>{r.name}</td><td className="ui-table__num">{r.score}</td></tr>
//     ))}</tbody>
//   </Table>
//
// Column helpers: className="ui-table__num" (right-align + tabular-nums),
// "ui-table__muted" (secondary ink).

import { TableHTMLAttributes, ReactNode } from 'react';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  /** Row hover highlight. */
  hover?: boolean;
  /** Wrap in the bordered card frame. Default true. */
  framed?: boolean;
  children: ReactNode;
}

export default function Table({ hover, framed = true, className, children, ...rest }: TableProps) {
  const table = (
    <table className={['ui-table', hover ? 'ui-table--hover' : '', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </table>
  );
  if (!framed) return <div className="ui-table-scroll">{table}</div>;
  return (
    <div className="ui-table-wrap">
      <div className="ui-table-scroll">{table}</div>
    </div>
  );
}
